import { Link } from "react-router-dom";
import { useBrandingAssets } from "@/hooks/useBrandingAssets";

export function CompactFooter() {
  const currentYear = new Date().getFullYear();
  const { logoUrl } = useBrandingAssets();

  return (
    <footer
      data-app-footer
      className="bg-footer border-t border-footer-border py-3"
    >
      <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs">
        <div className="flex items-center gap-2">
          {logoUrl && <img src={logoUrl} alt="Logo" className="h-5 w-auto" />}
          <p className="text-footer-muted">
            &copy; {currentYear} PayStreem. All rights reserved.
          </p>
        </div>
        <nav className="flex items-center gap-4">
          <Link
            to="/terms"
            className="text-footer-muted hover:text-footer-foreground transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            className="text-footer-muted hover:text-footer-foreground transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/support"
            className="text-footer-muted hover:text-footer-foreground transition-colors"
          >
            Support
          </Link>
        </nav>
      </div>
    </footer>
  );
}
